import { cn } from '@global/utils/tailwind'

export const PageHeader = ({ children, className = '' }) => (
  <div className={`flex justify-between w-full items-center px-8 ${className}`}>{children}</div>
)

const LeftBlock = ({ children, className = '' }) => (
  <div className={`flex items-center gap-3 ${className}`}>{children}</div>
)

const RightBlock = ({ children, className = '' }) => (
  <div className={`flex gap-2 ${className}`}>{children}</div>
)

const TitleContainer = ({ children, className = '' }) => (
  <div className={`flex flex-col text-left ${className}`}>{children}</div>
)

const Title = ({ children, className = '' }) => (
  <h1 className={`text-2xl font-bold mb-1 ${className}`}>{children}</h1>
)

const Description = ({ children, className = '' }) => (
  <p className={cn('text-base text-gray-600', className)}>{children}</p>
)

PageHeader.LeftBlock = LeftBlock
PageHeader.RightBlock = RightBlock
PageHeader.TitleContainer = TitleContainer
PageHeader.Title = Title
PageHeader.Description = Description
